import { useNavigate } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useProgress } from '../contexts/ProgressContext';
import { useGetModulesQuery } from '../redux/Clinictrainingapi';

export default function Sidebar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { getModuleProgress } = useProgress();
  const { data: modules } = useGetModulesQuery();

  let completedLessons = 0;
  let totalLessons = 0;
  (modules ?? []).forEach(m => {
    totalLessons += m.sections?.length ?? 0;
    completedLessons += (getModuleProgress(m.order).completedLessons?.length || 0);
  });
  const overallPercent = totalLessons > 0 ? Math.round((completedLessons / totalLessons) * 100) : 0;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="fixed left-0 top-0 bottom-0 w-16 bg-white border-r border-gray-200 hidden md:flex flex-col items-center py-4 z-50">
      {/* Logo */}
      <button
        onClick={() => navigate('/dashboard')}
        className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center mb-6 hover:bg-primary-dark transition-colors cursor-pointer"
      >
        <span className="text-white font-bold text-sm">N</span>
      </button>

      {/* Course book icon */}
      <button
        onClick={() => navigate('/dashboard')}
        className="w-10 h-10 rounded-lg flex items-center justify-center mb-2 hover:bg-cyan-50 transition-colors cursor-pointer group"
        title="Curriculum"
      >
        <BookOpen size={20} className="text-primary group-hover:text-primary-dark" />
      </button>

      {/* Progress bar */}
      <div className="w-1 flex-1 bg-gray-100 rounded-full my-4 relative overflow-hidden max-h-48">
        <div
          className="absolute top-0 left-0 w-full bg-primary rounded-full transition-all duration-500"
          style={{ height: `${overallPercent}%` }}
        />
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* User avatar */}
      <button
        onClick={handleLogout}
        className="w-9 h-9 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 text-sm font-semibold hover:bg-orange-200 transition-colors cursor-pointer"
        title={`${user?.name || 'User'} — Click to logout`}
      >
        {user?.name?.charAt(0) || 'U'}
      </button>
    </aside>
  );
}
